export type PermitsCustomFieldTypeName = typeof PermitsCustomFieldTypesNames[keyof typeof PermitsCustomFieldTypesNames]

export const PermitsCustomFieldTypesNames = {
  SHORT_TEXT: 0,
  EMAIL: 1,
  WHOLE_NUMBER: 2,
  PHONE_NUMBER: 3,
  SINGLE_SELECT: 4,
  LONG_TEXT: 5,
  ADDRESS_LOOKUP: 6,
  DATE_PICKER: 7,
  FILE_UPLOADER: 8,
  CHECKBOX: 9,
  CONTACT_INFORMATION: 10,
  ADDITIONAL_CONTACTS: 11,
  APPLICANT: 12,
  PRIMARY_LOCATION: 13,
} as const;
